<div class="app-layout">
  <main class="app-main">
    <router-outlet />
  </main>
  <app-site-footer />
</div>
